import React from 'react';
import cn from 'classnames';

import LogoIcon from '../../../assets/icons/common/LogoIcon';
import styles from './styles.module.scss';

const LayoutWithBg = ({ children, className, showLogo = true }) => {
  return (
    <div className={cn(styles.page, className)}>
      <main className={styles.main}>
        {showLogo && <LogoIcon className={styles.mainLogo} />}
        {children}
      </main>
    </div>
  );
};

export default LayoutWithBg;
